export class TrocarSenha {
  constructor({
    token = null,
    nomeDeUsuario = null,
    primeiroAcesso = null,
    visible = null,
  }) {
    this.token = token;
    this.nomeDeUsuario = nomeDeUsuario;
    this.primeiroAcesso = primeiroAcesso;
    this.visible = visible;
  }
  static Build() {
    return new TrocarSenha({
      token: null,
      nomeDeUsuario: null,
      primeiroAcesso: null,
      visible: null,
    });
  }
}
